import Radio from '../radio'
export default Radio.Item



// WEBPACK FOOTER //
// ./src/components/radio-item/index.js